import { render, staticRenderFns } from "./DeliverOrder.vue?vue&type=template&id=df2fe7dc&scoped=true&"
import script from "./DeliverOrder.vue?vue&type=script&lang=js&"
export * from "./DeliverOrder.vue?vue&type=script&lang=js&"
import style0 from "./DeliverOrder.vue?vue&type=style&index=0&id=df2fe7dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2fe7dc",
  null
  
)

export default component.exports